export enum AddressValidationStatus {
    NoValidationNeeded = "NO_VALIDATION_NEEDED", // Buitenland
    OverruledByCustomer = "OVERRULED_BY_CUSTOMER", // customer input
    Unknown = "UNKNOWN", // onbekend
    Validated = "VALIDATED", // BPOST validated

    Invalid = "INVALID", // Internal FE status
    Closed = "CLOSED" // Internal FE status
}
